import React from 'react';
import { Spinner } from 'react-bootstrap';
import './LoadingSpinner.scss';

// ローディング
export const LoadingSpinner: React.FC = () => {
  return (
    <div className="d-flex justify-content-center align-items-center spinner-container">
      <Spinner animation="border" role="status" variant="secondary"></Spinner>
    </div>
  );
};

export default LoadingSpinner;
